import React, {Fragment} from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import {Grow, Paper, Popper, Icon} from '@material-ui/core';
import {MenuItem, MenuList, List, ListItem, ListItemText, Link, Typography} from '@material-ui/core';

const MenuItemList = (props) => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
  
    const handleOver = (event) => setOpen(true)
    const handleClose = (event) => setOpen(false)
  
    function handleListKeyDown(event) {
      if (event.key === 'Tab') {
        event.preventDefault();
        setOpen(false);
      }
    }
  
    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
  
    React.useEffect(() => {
      if (prevOpen.current === true && open === false) { anchorRef.current.focus() } prevOpen.current = open
    }, [open]);

    const {menu, index,urlSite} = props

    return (     
        <>
        {menu.submenu ? (
            <ListItem className={`list_item menu-item menu-item-${menu.clave.toLowerCase()}`} onMouseOver={handleOver} onMouseLeave={handleClose} ref={anchorRef} disableGutters >
                <ListItemText /* onClick={handleClick} */ aria-controls={open ? `menu-list-grow-${index}` : undefined} aria-haspopup="true"
                primary={                                                             
                    <Typography noWrap><Link color="secondary" className="link-menu" href={`${urlSite}/${menu.link}`} >{menu.clave} <Icon>expand_more</Icon></Link></Typography>
                } />
                
                <Popper className={`popper-menu popper-menu-${menu.clave.toLowerCase()}`} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                    {({ TransitionProps, placement }) => (
                    <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'left top' : 'left bottom' }} >
                        <Paper className="popper-menu-paper">
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList onKeyDown={handleListKeyDown} autoFocusItem={open} id={`menu-list-grow-${index}`} >
                                    {menu.submenu.map((submenu, i) => (
                                        <MenuItem key={i} /* onClick={handleClick} */ disableGutters className="menu-item submenu" display="block">
                                            <Typography display="block">
                                                {submenu.link ? 
                                                ( <Link className="link-submenu" color="secondary" href={submenu.urlSite==='no'?submenu.link:`${urlSite}/${submenu.link}`} >{submenu.clave}</Link>) 
                                                : ( submenu.clave ) }
                                            </Typography>
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                    )}
                </Popper>
            </ListItem>                        
        ) : (
            <ListItem className={`list_item`}>
                <ListItemText className={`text_navlink`} primary={
                    <Typography noWrap><Link color="secondary" href={`${urlSite}/${props.menu.link}`} >{props.menu.clave}</Link></Typography>
                } />
            </ListItem>
        )}
        </>
        
    );
}

export default function MainNav(props) {

    const { sessionState, header, client } = props;

    return (
        <List className="navbar-list list">
             {header.menu
                .filter(menu => !menu.admin || (menu.admin && sessionState)) // Filtra los elementos del menú
                .map((menu, i) => (
                    <MenuItemList key={i} className={`text_navlink`} menu={menu} index={i} urlSite={client.urlSite} />
                ))
            }
        </List>
    )
}
